// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { getFunctions } from 'firebase/functions';
import { getAuth, signInAnonymously, onAuthStateChanged, onIdTokenChanged, updateProfile } from 'firebase/auth';
import { getDatabase, ref as databaseRef, onValue, set as databaseSet } from "firebase/database";
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCgC-S8GFxkK2LfRCodi1qLTbZuzW5uJJw",
  authDomain: "walterscube-b3767.firebaseapp.com",
  databaseURL: "https://walterscube-b3767.firebaseio.com",
  projectId: "walterscube-b3767",
  storageBucket: "walterscube-b3767.appspot.com",
  messagingSenderId: "482799415653",
  appId: "1:482799415653:web:bd08a161e168d56e46318c",
  measurementId: "G-RQGHSH7H81"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const functions = getFunctions(app);
const auth = getAuth(app);
const storage = getStorage(app);

// az auth baszott globalisra allitasa hogy a unity is lassa
window.fireAuth = new Object();
window.fireAuth.auth = auth;
window.fireAuth.signInAnonymously = signInAnonymously;
window.fireAuth.onAuthStateChanged = onAuthStateChanged;
window.fireAuth.onIdTokenChanged = onIdTokenChanged;
window.fireAuth.updateProfile = updateProfile;

window.fireDBase = new Object();
window.fireDBase.getDatabase = getDatabase;
window.fireDBase.ref = databaseRef;
window.fireDBase.onValue = onValue;
window.fireDBase.set = databaseSet;

window.fireStorage = new Object();
window.fireStorage.storage = storage;
window.fireStorage.ref = storageRef;
window.fireStorage.getDownloadURL = getDownloadURL;

window.fireAnal = new Object();
window.fireAnal.analytics = analytics;
window.fireAnal.logEvent = logEvent;
window.fireAnal.setUserId = setUserId;


// szar

export { app, analytics, functions, auth };